export default __webpack_public_path__ + "static/media/OpenSans-Regular.74fbb136.woff";